import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useEffect, useState } from "react";

interface Props {
  message: string;
  onClose?: () => void;
}

export const Success = ({ message, onClose }: Props) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 flex justify-center">
      <div className="border-green-100 bg-green-50 text-green-600 border-2 p-4 m-4 rounded flex items-center gap-2 min-w-[300px] justify-between">
        <div className="flex items-center gap-2">
          <CheckCircleIcon className="text-green-600" />
          {message}
        </div>
        <CancelIcon
          className="cursor-pointer"
          onClick={() => {
            setVisible(false);
            onClose?.();
          }}
        />
      </div>
    </div>
  );
};
